import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function ChevronLeftBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M10.2344 2.66699L4.90104 8.00033L10.2324 13.3337"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function ChevronRightBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M6.23307 2.66699L11.5664 8.00033L6.23307 13.3337"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function ChevronUpBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="17"
      width="16"
      fill="none"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M2.66602 10.2679L7.99935 4.93457L13.3327 10.2679"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function ChevronDownBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="17"
      width="16"
      fill="none"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M13.334 6.7321L8.00065 12.0654L2.66732 6.7321"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function CameraBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.93437 25.9998C5.25858 25.9953 4.61223 25.7226 4.13725 25.2419C3.66227 24.7612 3.3975 24.1116 3.40104 23.4358V10.6145C3.39714 9.9386 3.66181 9.28879 4.13686 8.80798C4.61192 8.32718 5.25847 8.05473 5.93437 8.0505H11.505L12.1944 5.6425C12.2517 5.37737 12.3943 5.13836 12.6005 4.96208C12.8066 4.78579 13.0649 4.68196 13.3357 4.6665H18.8317C19.1025 4.68196 19.3608 4.78579 19.5669 4.96208C19.7731 5.13836 19.9157 5.37737 19.973 5.6425L20.6624 8.0505H26.2304C26.9062 8.05508 27.5525 8.32766 28.0275 8.80839C28.5025 9.28912 28.7672 9.93871 28.7637 10.6145V23.4358C28.7669 24.1115 28.502 24.7609 28.0271 25.2415C27.5522 25.7222 26.906 25.9949 26.2304 25.9998H5.93437Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.77333"
      />
      <path
        d="M16.0625 22.0002C19.008 22.0002 21.3958 19.6123 21.3958 16.6668C21.3958 13.7213 19.008 11.3335 16.0625 11.3335C13.1169 11.3335 10.7291 13.7213 10.7291 16.6668C10.7291 19.6123 13.1169 22.0002 16.0625 22.0002Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function CancelBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M24 8L8 24"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="2.66667"
      />
      <path
        d="M8 8L24 24"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="2.66667"
      />
    </SvgIconComponent>
  )
}

export function DeactivateBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M5.5 7L26.5 4C27.3284 4 28 4.67158 28 5.5V8.5L4 11.5V8.5C4 7.67158 4.67158 7 5.5 7Z"
        fillRule="evenodd"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
      <path
        d="M16 20.5C17.6569 20.5 19 19.1569 19 17.5C19 15.8431 17.6569 14.5 16 14.5C14.3431 14.5 13 15.8431 13 17.5C13 19.1569 14.3431 20.5 16 20.5Z"
        fillRule="evenodd"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
      <path
        d="M25 13V28H7V15.625"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function DeleteBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M24.6697 15.5326V22.3627C24.6697 25.0874 23.5939 27.2954 20.8721 27.2954H11.481C8.75911 27.2954 7.68335 25.0818 7.68335 22.3542V15.5326M11.9186 15.5185V23.2267M16.1779 15.5185V23.2267M20.4386 15.5185V23.2267M19.0029 7.79894C19.0117 7.38746 18.9382 6.97836 18.7868 6.59564C18.6354 6.21292 18.4092 5.86427 18.1213 5.57015C17.8334 5.27603 17.4896 5.04235 17.1102 4.88282C16.7308 4.72329 16.3234 4.64111 15.9118 4.64111C15.5002 4.64111 15.0928 4.72329 14.7134 4.88282C14.334 5.04235 13.9903 5.27603 13.7024 5.57015C13.4145 5.86427 13.1882 6.21292 13.0368 6.59564C12.8854 6.97836 12.812 7.38746 12.8208 7.79894M27.2928 9.99988C27.2935 9.42301 27.0653 8.86942 26.6581 8.46072C26.251 8.05202 25.6983 7.82161 25.1215 7.82012H6.87722C6.5919 7.8203 6.30941 7.87668 6.04588 7.98604C5.78234 8.0954 5.54293 8.2556 5.3413 8.45748C5.13968 8.65937 4.9798 8.89899 4.87078 9.16267C4.76176 9.42634 4.70575 9.70891 4.70593 9.99423C4.70575 10.2796 4.76176 10.5621 4.87078 10.8258C4.9798 11.0895 5.13968 11.3291 5.3413 11.531C5.54293 11.7329 5.78234 11.8931 6.04588 12.0024C6.30941 12.1118 6.5919 12.1682 6.87722 12.1684H25.1186C25.6931 12.1702 26.2449 11.9439 26.6526 11.5391C27.0602 11.1344 27.2905 10.5843 27.2928 10.0098V9.99988Z"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function DownloadBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M28 19.9995V23.9998C28 25.0607 27.5786 26.0782 26.8284 26.8284C26.0782 27.5786 25.0607 28 23.9998 28H8.00024C6.93931 28 5.92181 27.5786 5.17162 26.8284C4.42143 26.0782 4 25.0607 4 23.9998V19.9995"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
      <path
        d="M16.0026 4V21.9989"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="1.77333"
      />
      <path
        d="M10.0052 16.3501L15.3479 21.6928C15.5366 21.8806 15.792 21.9861 16.0582 21.9861C16.3244 21.9861 16.5798 21.8806 16.7684 21.6928L21.9999 16.4611"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="bevel"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function EditBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M19.2347 8.38964L5.46475 22.1657L4 28L9.83429 26.5352L25.5139 10.8556L21.1444 6.48607L22.7266 4.90388C23.9318 3.69871 25.8909 3.69871 27.0961 4.90388C28.3013 6.10906 28.3013 8.06823 27.0961 9.27341"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function ReActiveBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M29.733 7.4668L24.1503 6.77868C23.988 6.75868 23.8414 6.87185 23.823 7.03144L23.187 12.522"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 12.6779 26.6501 9.67113 24.4688 7.49827"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function ShareBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M27.9994 13V5.49995C27.9993 5.10216 27.8413 4.72069 27.5599 4.43945"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
      <path
        d="M13 4H7C6.20435 4 5.44133 4.31607 4.87872 4.87868C4.31611 5.44129 4 6.20435 4 7V25C4 25.7956 4.31611 26.5587 4.87872 27.1213C5.44133 27.6839 6.20435 28 7 28H25C25.7956 28 26.5587 27.6839 27.1213 27.1213C27.6839 26.5587 28 25.7956 28 25V19"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
      <path
        d="M27.5605 4.4395C27.2793 4.15817 26.8978 4.00008 26.5 4H19"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
      <path
        d="M16 16L27.5605 4.43945"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.77333"
      />
    </SvgIconComponent>
  )
}

export function AddBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="17"
      width="16"
      fill="none"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M8 3.16016V13.8402V3.16016Z"
        fillRule="evenodd"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33"
      />
      <path
        d="M2.66016 8.5H13.3402H2.66016Z"
        fillRule="evenodd"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function SubstractBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="17"
      width="16"
      fill="none"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M3.33398 8.5H12.6673H3.33398Z"
        fillRule="evenodd"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function FullScreen({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="24"
      width="24"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M9.31341 9.31341L3.82814 3.82812M3.82814 3.82812H7.48499M3.82814 3.82812L3.82812 7.48498M14.8283 14.8281L20.3136 20.3134M20.3136 20.3134H16.6567M20.3136 20.3134V16.6566M9.31341 14.8281L3.82814 20.3134M3.82814 20.3134H7.48499M3.82814 20.3134L3.82812 16.6566M14.8283 9.31341L20.3136 3.82812M20.3136 3.82812H16.6567M20.3136 3.82812V7.48498"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SvgIconComponent>
  )
}

export function WindowMode({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="24"
      width="24"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <g clipPath="url(#clip0_1225_32799)">
        <path
          d="M3.89844 3.89941L9.38373 9.38469M9.38373 9.38469H5.72687M9.38373 9.38469V5.72784M20.3845 20.3847L14.8992 14.8994M14.8992 14.8994H18.5561M14.8992 14.8994V18.5563M3.89844 20.3847L9.38373 14.8994M9.38373 14.8994H5.72687M9.38373 14.8994V18.5563M20.3845 3.89941L14.8992 9.38469M14.8992 9.38469H18.5561M14.8992 9.38469V5.72784"
          stroke={stroke ?? '#141A21'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1225_32799">
          <rect height="24" width="24" fill={stroke ?? '#141A21'} />
        </clipPath>
      </defs>
    </SvgIconComponent>
  )
}

export function EllipseBold({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="32"
      width="32"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M7 13.6406C8.3048 13.6406 9.3623 14.6981 9.3623 16.0029C9.3623 17.3077 8.3048 18.3652 7 18.3652C5.6952 18.3652 4.6377 17.3077 4.6377 16.0029C4.6377 14.6981 5.6952 13.6406 7 13.6406Z"
        fill={stroke ?? '#141A21'}
        stroke="white"
        strokeWidth="0.89991"
      />
      <path
        d="M16 18.8154C17.5533 18.8154 18.8125 17.5562 18.8125 16.0029C18.8125 14.4496 17.5533 13.1904 16 13.1904C14.4467 13.1904 13.1875 14.4496 13.1875 16.0029C13.1875 17.5562 14.4467 18.8154 16 18.8154Z"
        fill={stroke ?? '#141A21'}
        fillRule="evenodd"
      />
      <path
        d="M25 18.8154C26.5533 18.8154 27.8125 17.5562 27.8125 16.0029C27.8125 14.4496 26.5533 13.1904 25 13.1904C23.4467 13.1904 22.1875 14.4496 22.1875 16.0029C22.1875 17.5562 23.4467 18.8154 25 18.8154Z"
        fill={stroke ?? '#141A21'}
        fillRule="evenodd"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes)),
  stroke: PropTypes.string
}

ChevronLeftBold.propTypes = iconPropTypes
ChevronRightBold.propTypes = iconPropTypes
ChevronUpBold.propTypes = iconPropTypes
ChevronDownBold.propTypes = iconPropTypes
CameraBold.propTypes = iconPropTypes
CancelBold.propTypes = iconPropTypes
DeactivateBold.propTypes = iconPropTypes
DeleteBold.propTypes = iconPropTypes
DownloadBold.propTypes = iconPropTypes
EditBold.propTypes = iconPropTypes
ReActiveBold.propTypes = iconPropTypes
ShareBold.propTypes = iconPropTypes
AddBold.propTypes = iconPropTypes
SubstractBold.propTypes = iconPropTypes
FullScreen.propTypes = iconPropTypes
WindowMode.propTypes = iconPropTypes
EllipseBold.propTypes = iconPropTypes

const iconsImageOverlay = {
  ChevronLeftBold,
  ChevronRightBold,
  ChevronUpBold,
  ChevronDownBold,
  CameraBold,
  CancelBold,
  DeactivateBold,
  DeleteBold,
  DownloadBold,
  EditBold,
  ReActiveBold,
  ShareBold,
  AddBold,
  SubstractBold,
  FullScreen,
  WindowMode,
  EllipseBold
}

export default iconsImageOverlay
